module.exports = __webpack_public_path__ + "static/opensans-lightitalic-webfont-c52995b1e14458cc8e8797a56c848274.woff";